import { HttpClient } from "@angular/common/http";
import { HttpClientBase } from "./http-client-base.service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class UanatacaService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'uanataca'); // La URL base para el servicio de usuarios
  }
  getRequestScratchcard(scratchcard: string) {
      return this.get<any>({endpoint: `scratchcards/${scratchcard}`});  
  }
}